import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import jaDefault from '~/locales/translation/ja/default.json';
import jaValidation from '~/locales/translation/ja/validation.json';

// @See https://react.i18next.com/latest/i18next-instance
// 多言語化する場合はresourcesにjaの要領で追加して、i18n.changeLanguage('en')のように切り替える
const resources = {
  ja: {
    translation: {
      ...jaDefault,
      ...jaValidation,
    },
  },
};

i18n
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    resources,
    fallbackLng: 'ja',
    // constantsからimportすると、constantsでのtranslation時にcircular dependencyエラーが出るため、constantsは使わない
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react
    },
  });
export default i18n;
